import React, {useContext, useEffect, useState} from 'react';
import { TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,
  ListOrderBy,
  ListRowRenderer
} from "../../common/AbstractListView";
import constants from '../../../constants';
import {Search} from "../../../filtering";

import * as XCol from '../../../framework.core/XExportColumn';

import {
  DateRenderer,
  DateTimeRenderer,
  FloatRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,
  TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext from '../../common/JobListViewContext';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import {JobNames} from "../../../framework.core/JobNames";
import {inventoryList} from "../tableSettings";
import {WhInvenSumListItem} from "../../../fms.data/models/WhInvenSumListItem";
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';

function ListCommands() {
  return <></>;
}

function ListToolbar() {
  return (
    <>
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);


  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2") {
    } else if (unprocessedFkey === "F3") {
    } else if (unprocessedFkey === "F9") {
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F7") {
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'F3', 'F9', 'F11', 'F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      hideMemoList={true}
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.WHInvenSummary}
      jobId={Number((jobListContext.selectedElement as WhInvenSumListItem|null)?.id) ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 * Concrete implementation for Other Shipment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.WHInvenSummary,
      'WhInvenSumListItem',
      WhInvenSumListItem.calculateSearchParameters(search, WhInvenSumListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: WhInvenSumListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.WHInvenSummary, 'WhInvenSumListItem',
      WhInvenSumListItem.calculateSearchParameters(search, WhInvenSumListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return WhInvenSumListItem.formatData(apiResult.entities);
  }


  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    // return [
    //   {accessor: 'centerNo', Cell: TextAlignLeftRenderer},
    //   {accessor: 'itemNo', Cell: TextAlignLeftRenderer},
    //   {accessor: 'itemDesc', Cell: TextAlignLeftRenderer},
    //   {accessor: 'upcCode', Cell: TextRenderer},
    //   {accessor: 'onHandQty', Cell: FloatRenderer},
    //   {accessor: 'allQty', Cell: FloatRenderer},
    //   {accessor: 'availQty', Cell: FloatRenderer},
    //   {accessor: 'boxUnit', Cell: FloatRenderer},
    //   {accessor: 'innerPcs', Cell: FloatRenderer},
    //   {accessor: 'onHandPcs', Cell: FloatRenderer},
    //   {accessor: 'allPcs', Cell: FloatRenderer},
    //   {accessor: 'availPcs', Cell: FloatRenderer},
    // ];
    return WhInvenSumListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.dataIndex === "status") {
        colRenderer.Cell = () => <span></span>
        colRenderer.Header = () => <span></span>;
      }
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if(x.type === XCol.XCellType.Double) {
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
      }
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({ accessor: 'onHandQty', changedValue: (value: any) => { return value['onHandQty'] } });
    colRenderer.push({ accessor: 'allQty', changedValue: (value: any) => { return value['allQty'] } });
    colRenderer.push({ accessor: 'availQty', changedValue: (value: any) => { return value['availQty'] } });
    colRenderer.push({ accessor: 'innerPcs', changedValue: (value: any) => { return value['innerPcs'] } });
    colRenderer.push({ accessor: 'onHandPcs', changedValue: (value: any) => { return value['onHandPcs'] } });
    colRenderer.push({ accessor: 'allPcs', changedValue: (value: any) => { return value['allPcs'] } });
    colRenderer.push({ accessor: 'availPcs', changedValue: (value: any) => { return value['availPcs'] } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'itemNo',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  inventoryList;
    const cols = WhInvenSumListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: WhInvenSumListItem) {
    return '';
  }

  getListViewTitle() {
    return 'Inventory List';
  };

  hasMemo(): boolean {
    return false;
  }
}

export default ListView;